import { render, staticRenderFns } from "./PopupComments.vue?vue&type=template&id=6752e990&"
import script from "./PopupComments.vue?vue&type=script&lang=ts&"
export * from "./PopupComments.vue?vue&type=script&lang=ts&"
import style0 from "./PopupComments.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports